import { Box, Center, HStack, Pressable, Text, VStack } from "native-base";
import React from "react";

import ExternalImage from "@/components/atoms/ExternalImage";
import { Product } from "@/interfaces/domain/Product";
import { Store } from "@/interfaces/domain/Store";
import { image_path_products_card } from "@/services/api";
import { adjustCaseText, formatToCurrency, formatWeight } from "@/utils/helpers";

type ProductCardProps = {
  product: Product;
  showStoreName?: boolean;
  onSelectProduct: () => void;
};

const ProductCard = ({ product, showStoreName = true, onSelectProduct }: ProductCardProps) => {
  const store = product?.estabelecimento as Store;
  const productPrice = product?.preco?.preco_encarte
    ? product?.preco?.preco_encarte
    : product?.preco?.preco_original;
  const productImage = product?.fotos_produto?.length
    ? product?.fotos_produto[0]
    : product?.foto_produto;
  const imageUrl = `${image_path_products_card}/${productImage}`;
  const isSale = !!product?.preco?.preco_encarte;
  const isUnity = product?.tipo_embalagem !== "kg";

  return (
    <Pressable onPress={onSelectProduct}>
      <HStack
        p="1"
        px="2"
        my="2"
        justifyContent="space-between"
        alignItems="center"
        space={4}
        bgColor="white.50"
        shadow="4"
        rounded="md">
        <VStack flex={0.6}>
          <Text fontSize="md" bold isTruncated>
            {adjustCaseText(product.nome)}
          </Text>
          <HStack py="1" space="5px" alignItems="center" flexWrap="wrap">
            <Text fontSize="lg" color="primary.600" bold>
              {isUnity
                ? formatToCurrency(productPrice) + "/und."
                : formatToCurrency(productPrice / product?.peso) + "/Kg"}
            </Text>
            {isSale && (
              <Text fontSize="sm" strikeThrough color="gray.600" bold>
                {isUnity
                  ? formatToCurrency(productPrice)
                  : formatToCurrency(product.preco?.preco_original / product?.peso) + "/Kg"}
              </Text>
            )}
          </HStack>
          {!isUnity && (
            <Text fontSize="md">
              {formatToCurrency(productPrice)} ≅ {formatWeight(product.peso)}
            </Text>
          )}
          {showStoreName && <Text isTruncated>{store.nome_fantasia}</Text>}
          {!showStoreName && <Text isTruncated>{product.categoria?.nome}</Text>}
        </VStack>
        <Box position="relative" flex={0.4}>
          {isSale && (
            <Box
              position="absolute"
              top={0}
              left={0}
              bgColor="secondary.400"
              p="1"
              rounded="lg"
              zIndex={999}>
              <Text fontSize="sm" textTransform="uppercase" color="primary.600" bold>
                Oferta
              </Text>
            </Box>
          )}
          <Box>
            <Center>
              <ExternalImage
                width={125}
                height={125}
                source={{ uri: imageUrl }}
                contentFit="contain"
              />
            </Center>
          </Box>
        </Box>
      </HStack>
    </Pressable>
  );
};

export default ProductCard;
